define('modules/targeting/video/main',["T1Module"], function (T1Module) {
  "use strict";

  return new T1Module({
    name: "targeting/video",
    viewCfgs: {
      panel: {
        collection: null
      },
      browse: {
        collection: null
      },
      filter: {
        collection: null
      },
      bins: {
        collection: null
      },
      readOnly: {
        model: null
      }
    },
    getView: function (type, opts) {
      if (type === "panel" || type === "bins") {
        opts.strategyTargetDimensions = opts.strategy.fetchTargetDimensions();
      }
      if (type === "bins") {
        opts.partialCollection = opts.strategyTargetDimensions.get("partial");
      }
      return T1Module.prototype.getView.call(this, type, opts);
    }
  });
});
